import React, { useEffect, useState } from 'react'
import PrimeTableFooter from '../../components/PrimeTableFooter'
import NoInfo from '../../components/NoInfo'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PrimeConfirmDialog from '../../components/dialog/PrimeConfirmDialog'
import { useTranslation } from 'react-i18next'
import { getSubItemsByItemNo } from '../../utility/service/api-service'
import { checkDpSuccess, getMaskedString } from '../../utility/service/tool-service'
import { updateAuditEyesEvent } from '../../utility/service/audilog-service'
import { useFuncId } from '../../router/menuRouterMapper'

// 共用元件 帳戶清單列表
/**
 * isType 依照身分別查詢的帳戶清單
 * ***/
export const CusCompanyAcctList = ({
    children,
    rows,
    btnReadMore,
    editItem,
    delDialog,
    setDelDialog,
    confirmDel,
    delObj,
    deleteItem,
    unlockItem,
    isType,
    isEditable = true
}) => {
    
    const { t } = useTranslation();
    const [maskView,setMaskView] = useState(false);
    const chsFuncId = useFuncId();
    const userNameTemplate = (rowData, props)=>{
        if(rowData){
            return (
            <>
              {rowData?.userName}({rowData?.issuer})
            </>)
        }
    } 

    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
          return (
            <>
                <Button tooltip={t('button.detail')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { editItem(rowData,"detail") }}>
                  <FontAwesomeIcon icon="fa-solid fa-eye" />
                </Button>
                <Button disabled={!isEditable} tooltip={t('button.delete')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { deleteItem(rowData) }}>
                  <FontAwesomeIcon icon="fa-solid fa-trash" />
                </Button>
                <Button disabled={rowData?.lockFlag!=='Y' || !isEditable} tooltip={t('button.unlock')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { unlockItem(rowData) }}>
                  <FontAwesomeIcon icon="fa-solid fa-lock" />
                </Button>
            </>
    
          )
    
        }
      }
    const masKAccountTemplate = (rowData, props) => {
      if(rowData){
        return (
          <>{!maskView?getMaskedString("account",rowData?.[props?.field]):rowData?.[props?.field]}</>
        )
      }
    }
    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:"V"
        })
        .then((res)=>{
            if(checkDpSuccess(res)){
    
            }
        })
    }

  return (
    <>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            {children}
        </div>
    </div>
   <div className="" style={{ top: "28px" }}>
      <Button
        type="button"
        icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
        severity="secondary"
        disabled={rows?.length===0}
        onClick={() => {
          setMaskView(prev => {
            if(!prev){
              axios_updateAuditEyesEvent();
            }
            return !prev;
          });
        }}
      />
    </div>
    <div className="p-card">
      <div className="" style={{ top: "28px" }}>
      </div>
        <div className="p-card-body">
            <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rows}
            footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />}
            emptyMessage={<NoInfo panel="table"/>}
            >

                <Column field="userName" header={t('user_name')} body={masKAccountTemplate} style={{ minWidth: '120px' }} />
                {/* <Column field="phone"  header={t('userPhone')} /> */}
                <Column field="email"  header={t('user_email')} body={masKAccountTemplate}  />
                {/* ps. 用 <></> 方式將兩個 Column 放一起會無法顯示 需用單條判斷方式顯示隱藏Column */}
                  {isType === "Y" && <Column field="companyName" header={t('org_name')} />}
                  {isType === "Y" && <Column field="companyTypeName" header={t('useType')} style={{ minWidth: '90px' }}  />}
                <Column field="roleName"  header={t('role_alias')} style={{ minWidth: '100px' }} />
                <Column field="statusName"  header={t('status')} style={{ minWidth: '80px' }} />
                <Column field="lastLogin"  header={t('lastLoginTime')} style={{ minWidth: '130px' }} />
                <Column style={{ minWidth: '200px' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
            </DataTable>
        </div>
    </div>
        {/* 刪除 */}
        <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => { setDelDialog(false) }}
        onConfirm={() => { confirmDel(); }}
        title={t('button.delete')}
        bodyTemplate={<>
        <div>
          {t('cf_del_user')}
        </div>
        <div>
          {t('user_name')}: {delObj?.userName}
        </div>
        </>}
      />
    </>
    
  )
}

